/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrateColor } from './CrateColor';
import {
    CrateColorFromJSON,
    CrateColorFromJSONTyped,
    CrateColorToJSON,
    CrateColorToJSONTyped,
} from './CrateColor';
import type { EVMChain } from './EVMChain';
import {
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    EVMChainToJSONTyped,
} from './EVMChain';

/**
 * Represents an NFT collection being tracked in the system
 * @export
 * @interface NftTracker
 */
export interface NftTracker {
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftTracker
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftTracker
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    grouping: string;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    contractAddress?: string;
    /**
     * 
     * @type {EVMChain}
     * @memberof NftTracker
     */
    evmChain?: EVMChain;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    openSea?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftTracker
     */
    isIneligibleForLeaderboards?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NftTracker
     */
    maxLimitMint?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NftTracker
     */
    useThirdwebEngine?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    relayerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    forwarderAddress?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftTracker
     */
    mintVirtually?: boolean;
    /**
     * Tracker is a BADGE — an on-account collectible, always virtual.
     * @type {boolean}
     * @memberof NftTracker
     */
    isBadge?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NftTracker
     */
    mintImage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftTracker
     */
    onChainRetired?: boolean;
    /**
     * 
     * @type {CrateColor}
     * @memberof NftTracker
     */
    crateColor?: CrateColor;
}



/**
 * Check if a given object implements the NftTracker interface.
 */
export function instanceOfNftTracker(value: object): value is NftTracker {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('grouping' in value) || value['grouping'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NftTrackerFromJSON(json: any): NftTracker {
    return NftTrackerFromJSONTyped(json, false);
}

export function NftTrackerFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftTracker {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'grouping': json['grouping'],
        'contractAddress': json['contractAddress'] == null ? undefined : json['contractAddress'],
        'evmChain': json['evmChain'] == null ? undefined : EVMChainFromJSON(json['evmChain']),
        'name': json['name'],
        'openSea': json['openSea'] == null ? undefined : json['openSea'],
        'isIneligibleForLeaderboards': json['isIneligibleForLeaderboards'] == null ? undefined : json['isIneligibleForLeaderboards'],
        'maxLimitMint': json['maxLimitMint'] == null ? undefined : json['maxLimitMint'],
        'useThirdwebEngine': json['useThirdwebEngine'] == null ? undefined : json['useThirdwebEngine'],
        'relayerUrl': json['relayerUrl'] == null ? undefined : json['relayerUrl'],
        'forwarderAddress': json['forwarderAddress'] == null ? undefined : json['forwarderAddress'],
        'mintVirtually': json['mintVirtually'] == null ? undefined : json['mintVirtually'],
        'isBadge': json['isBadge'] == null ? undefined : json['isBadge'],
        'mintImage': json['mintImage'] == null ? undefined : json['mintImage'],
        'onChainRetired': json['onChainRetired'] == null ? undefined : json['onChainRetired'],
        'crateColor': json['crateColor'] == null ? undefined : CrateColorFromJSON(json['crateColor']),
    };
}

export function NftTrackerToJSON(json: any): NftTracker {
    return NftTrackerToJSONTyped(json, false);
}

export function NftTrackerToJSONTyped(value?: NftTracker | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'grouping': value['grouping'],
        'contractAddress': value['contractAddress'],
        'evmChain': EVMChainToJSON(value['evmChain']),
        'name': value['name'],
        'openSea': value['openSea'],
        'isIneligibleForLeaderboards': value['isIneligibleForLeaderboards'],
        'maxLimitMint': value['maxLimitMint'],
        'useThirdwebEngine': value['useThirdwebEngine'],
        'relayerUrl': value['relayerUrl'],
        'forwarderAddress': value['forwarderAddress'],
        'mintVirtually': value['mintVirtually'],
        'isBadge': value['isBadge'],
        'mintImage': value['mintImage'],
        'onChainRetired': value['onChainRetired'],
        'crateColor': CrateColorToJSON(value['crateColor']),
    };
}

